import React, { Fragment } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const Container = styled.div`
  box-sizing: content-box;
  flex: 1 1 0px;
  display: flex;
  flex-direction: column;
  position: relative;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid rgba(196, 196, 196, 0.5);
  background-color: #FAFAFA;
  border: 1px solid rgba(196, 196, 196, 0.5);
  border-radius: 2px;
  padding: 10px;
  cursor: pointer;
  justify-content: space-between;
`;

const Title = styled.span`
  font-weight: 400;
  font-size: 16px;
  color: #626469;
  margin-left: 10px;
`;

const ItemsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  ${props => props.isOpen ? 'max-height: 1000px;' : 'max-height: 0px;'}
  transition: max-height 0.3s;
  overflow: hidden;
`;

const PaddingWrapper = styled.div`
  display: flex;
  flex: 1 1 0px;
  flex-direction: column;
  padding-top: 5px;
`;

const OpenArrowWrapper = styled.div`
  display: flex;
  box-sizing: content-box;
  width: 14px;
  height: 14px;
  transition: transform 0.3s;
  transform: ${props => props.isOpen ? 'rotate(180deg)' : 'rotate(0deg)'};
`;

class DocumentationDropdown extends React.Component {

  static propTypes = {
    title: PropTypes.string.isRequired,
    defaultOpenStatus: PropTypes.bool,
    children: PropTypes.array
  }

  constructor(props) {
    super(props);
    this.state = {
      isOpen: (props.defaultOpenStatus != null ? props.defaultOpenStatus : false)
    }
  }

  render = () => {
    return (
      <Container>
        <Header onClick={() => { this.setState({isOpen: !this.state.isOpen}); }}>
          <Title>{this.props.title}</Title>
          <OpenArrowWrapper isOpen={this.state.isOpen}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
              <path fill="currentColor" d="M134 347.2C126 339.2 126 325.2 134 317.2C138 313.2 144 311.2 149 311.2C155 311.2 160 313.2 164 317.2L510.6 663.5L860 315.5C864 311.5 869 309.5 875 309.5C880 309.5 886 311.5 890 315.5C898 323.5 898 337.5 890 345.5L526.6 708.5C517.6 716.5 504.6 716.5 495.6 708.5L134 347.2Z"/>
            </svg>
          </OpenArrowWrapper>
        </Header>
        <ItemsWrapper isOpen={this.state.isOpen}>
          <PaddingWrapper>
            {(this.props.children || []).map((child, idx) => {
              return (
                <Fragment key={idx}>
                  {child}
                </Fragment>
              );
            })}
          </PaddingWrapper>
        </ItemsWrapper>
      </Container>
    );
  }
}

export default DocumentationDropdown;
